import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FavouritesWrapper, FavouritesCounter } from './styles';
import IconFont from '../../../../components/shared/IconFont';
import FavouritesTooltip from '../../FavouritesTooltip/';
import ConfigManager from '../../../../common/configManager/configManager';
import LocalStorageUtility from '../../../../common/localStorageUtility/localStorageUtility';
import { EVENT_FRAME1_NAME } from '../../../../components/adv/Frame1Mobile';

class FavouritesToggle extends Component {
  constructor() {
    super();
    this.state = {
      showEmptyMessage: false,
      showNewFeatures: false,
    };
  }

  componentDidMount() {
    if (!LocalStorageUtility.hasNewFeatures()) {
      this.setState({
        showNewFeatures: true,
      });
      setTimeout(() => {
        this.setState({
          showNewFeatures: false,
        });
        LocalStorageUtility.setNewFeatures()
      }, 10000);
    }
  }

  handleFavourites = () => {
    document.dispatchEvent(new Event(EVENT_FRAME1_NAME));
    if (this.props.favouritesCounter > 0) {
      if (this.props.location.pathname !== ConfigManager.getRoute('favourites', process.env.REACT_APP_SITE)) {
        this.props.actions.push(ConfigManager.getRoute('favourites', process.env.REACT_APP_SITE));
        if (process.env.REACT_APP_SITE !== 'corriere' && window.omniture) {
          window.omniture.trkEventMc('Matchcenter preferiti');
        }
      }
    } else {
      this.setState({
        showEmptyMessage: true,
        showNewFeatures: false,
      });
      setTimeout(() => {
        this.setState({
          showEmptyMessage: false,
        });
      }, 2000);
    }
    if (this.props.location.pathname === ConfigManager.getRoute('favourites', process.env.REACT_APP_SITE)) {
      this.props.actions.push(ConfigManager.getRoute('hublive', process.env.REACT_APP_SITE));
    }
  };

  render() {
    const { favouritesCounter, isFavourite } = this.props;
    return (
      <React.Fragment>
        {this.state.showNewFeatures &&
          <FavouritesTooltip
            customText="Novit&agrave;: scegli i tuoi eventi sportivi preferiti e seguili live"
            size={12}
            noStar
            newFeatures
          />
        }
        <FavouritesWrapper
          id="favourites-toggle"
          onClick={this.handleFavourites}
          isSelectedFavourites={isFavourite}
        >
          {this.state.showEmptyMessage &&
            <FavouritesTooltip
              customText="Seleziona almeno un evento"
              size={12}
              noStar
            />
          }
          <IconFont
            className="icon-matchcenter-star"
            isSelectedFavourites={isFavourite}
            marginRight={0.5}
            withCursor
            color={favouritesCounter > 0 ? 'selectedColor' : 'lightGray'}
          />
          <FavouritesCounter
            isSelectedFavourites={isFavourite}
            color={favouritesCounter > 0 ? 'selectedColor' : 'lightGray'}
          >
            {favouritesCounter}
          </FavouritesCounter>
        </FavouritesWrapper>
      </React.Fragment>
    );
  }
}

FavouritesToggle.propTypes = {
  favouritesCounter: PropTypes.number,
  actions: PropTypes.any,
  location: PropTypes.any,
  isFavourite: PropTypes.bool,
};

export default FavouritesToggle;
